// Fictional Trends data for the bundled-sample mode (tests and demos without a
// database). Deterministic; the page labels it as sample data.
import type { Story } from "./model.ts";
import { buildTrends, type CountryDayRow, type StoryDayRow, type TrendsDoc } from "./trends.ts";

const COUNTRIES = ["US", "GB", "IN", "DE", "CA", "AU", "FR", "BR", "JP", "NL", "ZZ"];

export function sampleTrends(stories: Story[], now: number): TrendsDoc {
  const today = Math.floor(now / 86_400_000);
  const storyDays: StoryDayRow[] = [];
  const countryDays: CountryDayRow[] = [];
  stories.forEach((s, i) => {
    for (let d = 0; d < 45; d++) {
      const seed = (i * 7 + d * 13) % 11;
      if (seed > 6) continue;
      const opens = ((i + 3) * (d + 5)) % 9;
      storyDays.push({ storyId: s.id, day: today - d, opens, sources: Math.floor(opens / 2), saves: seed % 3 === 0 ? 1 : 0 });
    }
  });
  for (let d = 0; d < 45; d++)
    COUNTRIES.forEach((country, i) => {
      const opens = Math.max(6, 36 - i * 3 - ((d * (i + 1)) % 7));
      countryDays.push({ country, day: today - d, opens, sources: Math.floor(opens / 2), saves: Math.floor(opens / 6) });
    });
  const totals = new Map<string, StoryDayRow>();
  for (const r of storyDays) {
    const t = totals.get(r.storyId) ?? { storyId: r.storyId, day: 0, opens: 0, sources: 0, saves: 0 };
    t.opens! += r.opens ?? 0;
    t.sources! += r.sources ?? 0;
    t.saves! += r.saves ?? 0;
    totals.set(r.storyId, t);
  }
  const meta = new Map(stories.map((s) => [s.id, { title: s.title, topic: s.primaryTopic, type: s.contentType }]));
  return { ...buildTrends({ storyDays, storyTotals: [...totals.values()], countryDays, stories: meta, now }), isSample: true };
}
